import { render, staticRenderFns } from "./SpriteMap.vue?vue&type=template&id=4d8f2bf0&scoped=true"
import script from "./SpriteMap.vue?vue&type=script&lang=js"
export * from "./SpriteMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f2bf0",
  null
  
)

export default component.exports